import Cookies from "js-cookie";
import authType from "./authTypes";

export const logoutUserLocallyAction = (loginModalState = false) => {
  return (dispatch) => {
    dispatch({ type: authType["LOGOUT_USER"], payLoad: {} });
    // destroyLastLogin();
    Cookies.remove("token");
    localStorage.removeItem("user");
    Cookies.remove("team");
    Cookies.remove("outlet");
    localStorage.removeItem("undefined_reducer");
    window.location.reload(false);
  };
};
